import { ActionWithPayload, RehydrateOptions } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { JURISDICTION_ACTION_TYPE } from "./jurisdiction.action";
import { JurisdictionState } from "./jurisdiction.model";

const INITIAL_STATE: JurisdictionState = {};

const rehydrateOptions: RehydrateOptions<JurisdictionState> = {
	name: "jurisdictionReducer",
};

export function jurisdictionReducer(state = INITIAL_STATE, action: ActionWithPayload): JurisdictionState {
	switch (action.type) {
		case JURISDICTION_ACTION_TYPE.getSuccess:
		case JURISDICTION_ACTION_TYPE.set: {
			if (state.jurisdiction === action.payload) {
				return state;
			}
			return updateState(state, {
				jurisdiction: action.payload,
			});
		}
		default:
			return state;
	}
}

jurisdictionReducer.prototype.rehydrateOptions = rehydrateOptions;
